import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('enable_ui_modifications_for_it_agent_view');
	},
};
